<template>
  <div class="ui-content">
    <div class="ui-box">
      <el-form ref="form" class="ui-box-from-vaccineDetail" label-position="right" :model="form" label-width="150px">
        <div class="ui-box-item">
          <titleComponents :show.sync="show" name="疫苗信息"></titleComponents>
          <div class="itemInfo-detail" v-show="show">
            <div class="baseInfo-content">
              <div class="text">昵称：{{$route.query.name||''}}</div>
              <div class="text">手机号：{{$route.query.phone||''}}</div>
            </div>
            <table class="ui-box-table">
              <tr>
                <th style="width:18.4%">月龄</th>
                <th style="width:24.9%">疫苗时间</th>
                <th style="width:22.3%">疫苗名</th>
                <th style="width:34.4%">预防</th>
              </tr>
              <tr v-for="(item,index) in list" :key="index">
                <td>{{item.monthAge||''}}</td>
                <td>{{item.tbVaccineTime||''}}</td>
                <td>{{item.tbVaccineName||''}}</td>
                <td>{{item.tbPrevention||''}}</td>
              </tr>
            </table>
          </div>
        </div>
      </el-form>
      <div class="ui-box-vaccineDetail-button">
        <el-button class="return" @click="returnList">返回列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const files = require.context('/', false, /\.vue$/);
const suffixList = files.id
  .split(' ')[0]
  .split('/')
  .filter((a, b) => b > 2);
const fileName = 'vaccineDetail';
const controller = 'user';
const parentName = '疫苗提醒';
import titleComponents from '@/components/mother/title'
import { mapGetters } from 'vuex';
export default {
  name: `${suffixList.join('')}${fileName}`,
  data () {
    const _this = this;
    return {
      list: [],
      show: true,
      pathCode: `${suffixList.join('')}${fileName}`,
      loading: false,
      filePath: ['', ...suffixList, fileName].join('/'),
      fileName: fileName,
      form: {
      },
    };
  },
  computed: {
    isSee () {
      return false;
    },
    pageType () {
      return 'edit';
    },
    ...mapGetters(['lastBreadCrumb', 'refreshPage'])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.init();
        this.$store.dispatch('setRefreshPage', false);
      }
    }
  },
  methods: {
    clear () {
      this.list = []
    },
    init () {
      this.clear();
      this.getById(this.$route.query.tbId);
    },
    initForm (form) {
      return form;
    },
    getById (id) {
      this.$http.get(`/${controller}/findVaccineDetail`, { tbId: id }).then((res) => {
        if (res.code === 1000) {
          this.list = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    returnList () {
      this.closeTab(
        this.filePath,
        parentName,
        this.fileName,
        ['', ...suffixList].join('/'),
        true
      );
    }
  },
  created () {
    this.init();
  },
  mounted () { },
  destroyed () { },
  components: {
    titleComponents
  }
};
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    overflow-x: auto;
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-vaccineDetail {
      padding-top: 4px;
      .ui-box-item {
        margin: 20px 24px 0;
        background: rgba(0, 0, 0, 0.02);
        box-sizing: border-box;
        width: calc(100% - 48px);
        .itemInfo-detail {
          border-top: 1px solid #e5e5e5;
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          .baseInfo-content {
            display: flex;
            align-content: center;
            margin-bottom: 25px;
            .text {
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              line-height: 22px;
              margin-right: 60px;
            }
          }
          .ui-box-table {
            table-layout: fixed;
            text-align: center;
            width: 100%;
            border: 1px solid #d8d8d8;
            border-radius: 6px;
            border-collapse: collapse;
            border-style: hidden;
            box-shadow: 0 0 0 1px #e0e0e0;
            overflow: hidden;
            tr {
              border: 1px solid #e0e0e0;
              height: 54px;
              line-height: 54px;
              th {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 700;
                color: #000000;
                text-align: center;
                border: 1px solid #e0e0e0;
              }
              td {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                border: 1px solid #e0e0e0;
              }
            }
          }
        }
      }
      .ui-box-vaccineDetail-button {
        margin-left: 217px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #555555;
        .return {
          margin-top: 20px;
          padding: 6px 25px;
          margin-right: 40px;
          border-radius: 3px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          line-height: 22px;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
}
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-vaccineDetail {
      padding-top: 4px;
      .ui-box-item {
        margin: 20px 24px 0;
        background: rgba(0, 0, 0, 0.02);
        box-sizing: border-box;
        width: calc(100% - 48px);
        .itemInfo-detail {
          border-top: 1px solid #e5e5e5;
          width: 100%;
          padding: 20px;
          box-sizing: border-box;
          .baseInfo-content {
            display: flex;
            align-content: center;
            margin-bottom: 25px;
            .text {
              font-weight: 400;
              font-size: 14px;
              color: #000000;
              line-height: 22px;
              margin-right: 60px;
            }
          }
          .ui-box-table {
            table-layout: fixed;
            text-align: center;
            width: 100%;
            border: 1px solid #d8d8d8;
            border-radius: 6px;
            border-collapse: collapse;
            border-style: hidden;
            box-shadow: 0 0 0 1px #e0e0e0;
            overflow: hidden;
            tr {
              border: 1px solid #e0e0e0;
              height: 54px;
              line-height: 54px;
              th {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 700;
                color: #000000;
                text-align: center;
                border: 1px solid #e0e0e0;
              }
              td {
                background: #ffffff;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
                border: 1px solid #e0e0e0;
              }
            }
          }
        }
      }
    }
    .ui-box-vaccineDetail-button {
      margin-left: 217px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        margin-top: 20px;
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>